module.exports = __webpack_public_path__ + "img/do-something-great.d4d9b172.jpg";